import { Modal } from '@/components';
import { useAuth } from '@/features/auth/AuthProvider';
import { useNavigate } from '@solidjs/router';
import { RegisterDeviceForm } from './RegisterDeviceForm';

export const RegisterDeviceModal = (props: { open: boolean; onClose: () => void }) => {
  const navigate = useNavigate();
  const { session } = useAuth();
  const canList = () => session()?.permissions.has('devices:list') ?? false;

  return (
    <Modal open={props.open} onClose={props.onClose} title="Register device">
      <RegisterDeviceForm
        onCancel={props.onClose}
        onRegistered={() => props.onClose()}
        onClaimed={(deviceId) => {
          props.onClose();
          navigate(canList() ? `/devices/${deviceId}` : '/devices/me');
        }}
        onViewDevice={(deviceId) => {
          props.onClose();
          navigate(`/devices/${deviceId}`);
        }}
      />
    </Modal>
  );
};
